export default __webpack_public_path__ + "static/media/BatchPrint_Dark2.0580fae1.svg";